import { faqData } from '@/mocks/homepage';

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-4">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-question-line text-sm"></i>
            </div>
            常见问题
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 font-heading mb-3">
            关于玫瑰视频的常见疑问
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            关于91视频网站、久久视频和91在线视频的使用问题，这里都有答案
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((item) => (
            <details
              key={item.id}
              className="group bg-background-100 rounded-xl border border-background-200/60 overflow-hidden"
            >
              <summary className="flex items-center justify-between p-5 cursor-pointer hover:bg-accent-50/30 transition-colors list-none">
                <h3 className="text-base font-bold text-foreground-900 font-heading pr-4">
                  {item.q}
                </h3>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 group-open:rotate-180 transition-transform">
                  <i className="ri-arrow-down-s-line text-foreground-500 text-lg"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}